import http from '@/utils/http'

const initialState = () => ({
  list: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list
  }
}

export const getters = {
  list: state => state.list
}

export const actions = {
  fetchPlugins ({ getters, commit, rootGetters }) {
    if (getters.list.length) {
      return getters.list
    }

    return http({
      url: `${process.env.VUE_APP_API_URL}plugins/${rootGetters['auth/token']}`
    }).then(data => {
      commit('SET_LIST', data)

      return data
    })
  },
  addParamsByPlugin ({ commit, dispatch, rootGetters }, { plugin, job }) {
    return http({
      url: `${process.env.VUE_APP_API_URL}logic/parameters/${rootGetters['auth/token']}/${plugin}`
    }).then(parameters => {
      const promises = []
      for (const param of parameters) {
        promises.push(dispatch('jobParameters/saveParam', {
          JobID: job.ID,
          Key: param.ParameterName,
          DataConnectorName: job.DataConnectorPluginDestination,
          IsDestination: true
        }, { root: true }))
      }

      if (promises.length) {
        return Promise.all(promises)
      }
    })
  }
}
